// extracted by mini-css-extract-plugin
export default {"card":"FavCard_card__fhWSH"};